import '@fortawesome/fontawesome-free/css/all.css'
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'fa',
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        pink: '#ff9478',
        'grey-1': '#9ba5b1',
        'grey-2': '#22262b',
        'grey-3': '#1d2125',
        'grey-4': '#16191d',
      }
    }
  }
});
